<template>
  <div class="searchItem">
    <div class="searchItemLeft">
      <span>{{ title }}：</span>
    </div>
    <div class="searchItemContent" v-if="type == 'keyword'">
      <input type="text" :placeholder="placeholderText" class="keyword" v-model="key" :lxUrl="lxUrl" @input="input"
        @change="keyChange()" @focus="keyFocusFn()" @blur="keyBlurFn()" />
      <img src="@/common/img/tipsIco.png" v-show="hiddenTips" style="position:absolute;left:470px;top:4px;width:20px;"
        v-on:mouseover="changeTipsState()" v-on:mouseleave="changeTipsState()" />
      <!-- <div
        style="position:absolute;top:36px;background-color:#ffffff;z-index:9;padding:5px;border-radius:10px;"
        v-show="hiddenTips && tipsState"
      ></div>-->

      <div class="searchTips" v-show="hiddenTips && tipsState">
        <em><img src="@/common/img/searchTopBtn1.png" /></em>
        <div class="tipsCon" v-html="tipsContent"></div>
      </div>
    </div>

    <div class="keyTips" v-if="type == 'keyword'" v-show="keyFocus && zzList.length > 0">
      <div v-for="(item, index) in zzList" :key="index" @click="clickKeyTip(item)">{{ item }}</div>
      <div class="scrollbar"></div>
    </div>

    <div class="searchItemContent" v-if="type == 'normal'">
      <div v-for="(item, index) in items" :key="index" class="searchItemContentItem">
        <!-- 一级分类 -->
        <span :class="busClass(item.state) + (item.id === '' ? ' diytitle' : '')"
          v-on:click="select(item.id, item.all, item.state)">{{ item.name }}</span>
      </div>
      <div class="cl_f"></div>
      <!-- 二级分类 -->
      <div class="small" v-if="levelTwoData.length > 0 ? true : false">
        <div v-for="(small, sIndex) in levelTwoData" :key="sIndex" class="smallItem">
          <span :class="small.state == 0 ? 'natural' : 'select'"
            v-on:click="selectLevelTwo(small.parentId, small.parentIndex, sIndex, small.all, small.state)">
            {{ small.name }}
          </span>
        </div>
      </div>
    </div>

    <div class="cl_f"></div>

    <div class="searchAreaContent" v-if="type == 'area'">
      <div class="searchAreaContentItem">
        <!-- 地区全国 -->
        <span :class="areaData.state == 0 ? 'natural' : 'select'" v-on:click="selectAreaAll()">{{ areaData.name
          }}</span>
        <!-- 一级地区 -->

        <div v-for="(area, areaIndex) in areaData.list" :key="areaIndex">
          <div class="verticalLine"></div>
          <span :class="areaClass(areaData.state, area.state) + ' hui'"
            v-on:click="selectAreaLevelOne(area.id, areaIndex)">{{ area.name }}</span>
          <!-- 二级地区 -->
          <div v-for="(item, index) in area.list" :key="index">
            <span :class="areaClass(areaData.state, area.state, item.state)"
              v-on:click="selectAreaLevelTwo(areaIndex, index)">{{ item.name }}</span>
          </div>
        </div>
      </div>
      <div class="cl_f"></div>
    </div>
    <!-- 项目金额 -->
    <div class="searchAreaContent" v-if="type == 'objMoney'">
      <div class="searchAreaContentItem">
        <input type="number" class="keyword" v-model="startMoney" style="width: 200px;" placeholder="请输入最小项目金额(包含)" />
        <span style="padding: 0 12px !important;margin-right:0">-</span>
        <input type="number" class="keyword" v-model="endMoney" style="width: 200px;"
          placeholder="请输入最大项目金额(包含)" /><span
          style="padding: 0!important;margin-right:0;margin-left: 10px;line-height: 25px;">万元</span>
      </div>
      <div class="cl_f"></div>
    </div>
    <!-- 项目金额 End -->

    <div class="searchItemContent" v-if="type == 'time'">
      <div v-for="(item, index) in timeData" :key="index" class="searchItemContentItem">
        <span :class="item.state == 0 ? 'natural' : 'select'" v-on:click="selectTime(item.id, index, item.state)">{{
          item.name }}</span>
        <div class="cl_f"></div>
      </div>
      <div class="timeSelect">
        <el-date-picker v-model="startTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
          v-on:input="startTimeChange" :clearable="false" :picker-options="pickerOptionsStart"></el-date-picker>
        <span style="padding:0 8px;">至</span>
        <el-date-picker v-model="endTime" type="date" placeholder="选择日期" value-format="yyyy-MM-dd"
          v-on:input="endTimeChange" :clearable="false" :picker-options="pickerOptionsEnd"></el-date-picker>
        <!-- <el-date-picker
          type="daterange"
          value-format="yyyy-MM-dd"
          align="left"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          v-model="timeValue"
          @input="timeChange"
        ></el-date-picker>-->
      </div>
      <div class="selectYear" v-if="noYear == null ? true : false">
        <span class="demonstration">快速选择年份</span>
        <el-date-picker v-model="yearValue" @input="yearSelect" type="year" placeholder="选择年"
          :picker-options="pickerOptionsYearStart"></el-date-picker>
      </div>
    </div>
    <div class="searchItemContent" v-if="type == 'etime'">
      <div class="timeSelect">
        <el-time-select v-model="startTime" :picker-options="{
          start: '06:00',
          step: '00:15',
          end: '24:00'
        }" placeholder="选择时间" v-on:input="estartTimeChange"></el-time-select>

        <span style="padding:0 8px;">至</span>
        <!-- <el-time-picker v-model="endTime" placeholder="选择时间" v-on:input="endTimeChange"></el-time-picker> -->
        <!-- <el-time-select
          v-model="endTime"
          :picker-options="{
            start: '06:00',
            step: '00:15',
            end: '24:00'
          }"
          placeholder="选择时间"
          v-on:input="eendTimeChange"
        ></el-time-select> -->
        <el-time-select v-model="endTime" :picker-options="type_etime.endPicker_options" placeholder="选择时间"
          v-on:input="eendTimeChange"></el-time-select>
      </div>
    </div>
    <div class="searchItemContent" v-if="type == 'radio'">
      <div class="searchItemContentItem">
        <el-radio-group v-model="radioValue" style="float:left;" @change="selectRadio">
          <el-radio :label="item.id" v-for="item in items" :key="item.id">{{ item.name }}</el-radio>
        </el-radio-group>
      </div>
    </div>
  </div>
</template>

<script>
import { type } from 'os';
import { constants } from 'fs';
import { base } from '@/common/js/base.js';
import { clearInterval } from 'timers';
export default {
  name: 'searchItem',
  components: {},
  data() {
    return {
      type_etime: {
        endPicker_options: {
          start: '06:00',
          step: '00:15',
          end: '24:00'
        }
      },
      startMoney: '',
      endMoney: '',
      levelTwoState: false,
      levelTwoData: [],
      timeValue: '',
      yearValue: '',
      industryTypeValue: 1,
      radioValue: 60,
      etimeValue: [new Date(2016, 9, 10, 9, 0), new Date(2016, 9, 10, 21, 0)],
      key: '',
      onload: this.pageOnLoad,
      startTime: '09:00',
      endTime: '21:00',
      timer: '',
      tipsState: false,
      zzList: [],
      keyFocus: false,
      pickerOptionsStartNow: 1609430400000, //2021-01-01 00:00:00 时间戳
      // pickerOptionsStartNow: 1514736000000, //2018-01-01 00:00:00 时间戳
      // pickerOptionsStartNow: 1577808000000, //2020 00:00:00 时间戳
      pickerOptionsStart: {
        //开始时间
        disabledDate: time => {
          let now = this.pickerOptionsStartNow;
          return time.getTime() > Date.now() || time.getTime() < now;
        }
      },
      pickerOptionsYearStart: {
        //开始时间
        disabledDate: time => {
          let now = this.pickerOptionsStartNow;
          return time.getTime() > Date.now() || time.getTime() < now;
        }
      },
      pickerOptionsEnd: {
        //结束时间
        disabledDate: time => {
          let now = this.pickerOptionsStartNow;
          return time.getTime() > Date.now() || time.getTime() < now;
        }
      }
    };
  },
  props: [
    'items',
    'type',
    'title',
    'areaData',
    'timeData',
    'isSelectOne',
    'noYear',
    'radioDefaultValue',
    'keyword',
    'defaultTime',
    'pageOnLoad',
    'hiddenTips',
    'tipsContent',
    'isSecond',
    'dataId',
    'lxUrl',
    'placeholderText'
  ],
  methods: {
    selectRadio() {
      console.log(this.radioValue, 6993);
      this.$emit('selectRadio', this.radioValue);
    },
    keyChange: function () {
      console.log(this.key);
      this.$emit('keyChange', this.key);
    },
    changeTipsState: function () {
      if (this.tipsState) {
        this.tipsState = false;
      } else {
        this.tipsState = true;
      }
    },
    //区域数据选中
    input: function () {
      if (this.timer != null && this.timer != '') {
        clearTimeout(this.timer);
      }
      var that = this;
      that.timer = setTimeout(function () {
        that.openBind();
      }, 1000);
    },
    selectAreaAll: function () {
      var that = this;
      var areaData = that.areaData;
      var state = areaData.state;
      if (state == 0) {
        areaData.state = 1;
      } else if (state == 1) {
        areaData.state = 0;
      }
      for (var i = 0; i < areaData.list.length; i++) {
        var area = areaData.list[i];
        if (state == 0) {
          area.state = 1;
        } else {
          area.state = 0;
        }
        for (var j = 0; j < area.list.length; j++) {
          if (state == 0) {
            area.list[j].state = 1;
          } else {
            area.list[j].state = 0;
          }
        }
        areaData.list[i] = area;
      }
      that.openBind();
    },
    selectAreaLevelOne: function (id, index) {
      var that = this;
      var areaData = that.areaData;
      var list = areaData.list;
      var hArea = list[index];
      var state = hArea.state;
      if (state == 0) {
        hArea.state = 1;
      } else {
        hArea.state = 0;
        areaData.state = 0;
      }
      for (var i = 0; i < hArea.list.length; i++) {
        if (state == 0) {
          hArea.list[i].state = 1;
        } else {
          hArea.list[i].state = 0;
        }
      }
      areaData.list[index] = hArea;
      that.areaData = areaData;
      that.openBind();
    },
    selectAreaLevelTwo: function (areaIndex, index) {
      var that = this;
      var areaData = that.areaData;
      var list = areaData.list;
      var hArea = list[areaIndex];
      var hlist = hArea.list;
      var item = hlist[index];
      var state = item.state;
      if (state == 0) {
        item.state = 1;
      } else {
        item.state = 0;
        hArea.state = 0;
        areaData.state = 0;
      }
      hArea.list[index] = item;
      areaData.list[areaIndex] = hArea;
      that.areaData = areaData;
      that.openBind();
    },
    // 时间选择
    selectTime: function (id, index, state) {
      var that = this;
      var timeData = that.timeData;
      for (var i = 0; i < timeData.length; i++) {
        if (timeData[i].id == id) {
          if (state == 0) {
            timeData[i].state = 1;
          } else {
            // timeData[i].state = 0;
          }
        } else {
          timeData[i].state = 0;
        }
      }
      that.timeData = timeData;
      that.timeType_selected(index);
    },
    timeChange: function () {
      var that = this;
      var timeData = that.timeData;
      for (var i = 0; i < timeData.length; i++) {
        timeData[i].state = 0;
      }
      that.timeData = timeData;
      that.openBind();
    },
    // 时间范围：单选
    timeType_selected: function (index) {
      console.log('进来了4,' + index);
      var that = this;
      that.timeTypeArray = index;

      if (that.timeTypeArray == 0) {
        //选择近一个星期
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
        that.startTime = new base().formatDate(start);
        that.endTime = new base().formatDate(end);
        // that.timeValue = [start, end];
        // that.timeData = [start, end];
      } else if (that.timeTypeArray == 1) {
        //选择近半个月
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 15);
        that.startTime = new base().formatDate(start);
        that.endTime = new base().formatDate(end);
        // that.timeData = [start, end];
      } else if (that.timeTypeArray == 2) {
        //选择近一个月
        // const end = new Date();
        // const start = new Date().setMonth(end.getMonth() - 1);
        // that.startTime = new base().formatDate(start);
        // that.endTime = new base().formatDate(end);

        //that.timeData[3].state=1;

        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
        that.startTime = new base().formatDate(start);
        that.endTime = new base().formatDate(end);
        // that.timeData = [start, end];
      } else if (that.timeTypeArray == 3) {
        //选择近三个月
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
        that.startTime = new base().formatDate(start);
        that.endTime = new base().formatDate(end);
        // that.timeData = [start, end];
      } else if (that.timeTypeArray == 4) {
        //选择近半年
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 180);
        that.startTime = new base().formatDate(start);
        that.endTime = new base().formatDate(end);
        // that.timeData = [start, end];
      } else if (that.timeTypeArray == 5) {
        console.log('进来了5');
        //选择近一年
        const end = new Date();
        const start = new Date();
        start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
        that.startTime = new base().formatDate(start);
        that.endTime = new base().formatDate(end);
        // that.timeData = [start, end];
      } else if (that.timeTypeArray == 6) {
        //不限
        that.startTime = '';
        that.endTime = '';
        // that.timeData = [start, end];
      }
      // console.log(that.startTime)
      // console.log(that.endTime)
      that.openBind();
    },
    yearSelect: function () {
      var that = this;
      var timeData = that.timeData;
      for (var i = 0; i < timeData.length; i++) {
        timeData[i].state = 0;
      }
      that.timeData = timeData;
      var yearVal = that.$moment(that.yearValue).format('YYYY');
      var startTimeSet = yearVal + '-01-01';
      var endTimeSet = yearVal + '-12-31';
      // that.timeValue = [startTimeSet, endTimeSet];
      that.startTime = startTimeSet;
      that.endTime = endTimeSet;
      // that.timeData = [startTimeSet, endTimeSet];
      that.openBind();
    },
    //普通选中
    select: function (id, all, state) {
      var that = this;
      console.log('id:', id);
      console.log('state:', state);
      console.log('all:', all);
      that.checkSelectState();
      var items = that.items;
      var item;
      if (all != null && all == 1) {
        for (var i = 0; i < items.length; i++) {
          if (items[i].id == id) {
            item = items[i];
            break;
          }
        }
        var state = item.state;
        if (state == 0) {
          for (var i = 0; i < items.length; i++) {
            items[i].state = 1;
          }
        } else if (state == 1) {
          for (var i = 0; i < items.length; i++) {
            items[i].state = 0;
          }
        }
      } else {
        for (var i = 0; i < items.length; i++) {
          item = items[i];
          if (item.id == id) {
            if (item.list == null) {
              if (state == 0) {
                item.state = 1;
              } else if (state == 1) {
                if (that.isSelectOne) {
                  item.state = 1;
                } else {
                  item.state = 0;
                }
                if (items[0].all != null) {
                  items[0].state = 0;
                }
              }
            } else {
              if (state == 0) {
                item.state = 2;
                that.showLevelTwoSelect(item.list);
              } else if (state == 1) {
                item.state = 2;
                that.showLevelTwoSelect(item.list);
              } else if (state == 2) {
                that.showLevelTwoSelect([]);
                that.checkSelectState();
              }
            }
            items[i] = item;
            if (that.isSelectOne == null || that.isSelectOne == false) {
              break;
            }
          } else {
            if (that.isSelectOne) {
              items[i].state = 0;
            }
          }
        }
      }
      that.items = items;
      this.$root.industryTypeValue = id;
      this.industryTypeValue = id;
      that.$emit('select');
      that.openBind();
    },

    selectLevelTwo: function (parentId, parentIndex, sIndex, all, state) {
      var that = this;
      var items = that.items;
      // 小类全选
      if (all != null && all == 1) {
        var parent = items[parentIndex];
        if (state == 0) {
          parent.state == 1;
          for (var i = 0; i < parent.list.length; i++) {
            parent.list[i].state = 1;
          }
        } else if (state == 1) {
          parent.state == 0;
          for (var i = 0; i < parent.list.length; i++) {
            parent.list[i].state = 0;
          }
        }
        items[parentIndex] = parent;
      } else {
        if (state == 0) {
          items[parentIndex].list[sIndex].state = 1;
        } else if (state == 1) {
          items[parentIndex].list[sIndex].state = 0;
          items[parentIndex].list[0].state = 0;
        }
      }
      that.$emit('selectLevelTwo');
    },
    showLevelTwoSelect: function (levelTwoData) {
      var that = this;
      that.levelTwoData = [];
      if (levelTwoData != null && levelTwoData.length > 0) {
        that.levelTwoData = levelTwoData;
      }
      that.openBind();
    },
    // 检验state，主要是子类的state与父类关联是否正确
    checkSelectState: function () {
      var that = this;
      var items = that.items;
      for (var i = 0; i < items.length; i++) {
        var item = items[i];
        var list = item.list;
        if (list == null) {
          continue;
        } else {
          var selectNum = 0;
          for (var j = 0; j < list.length; j++) {
            var child = list[j];
            if (child.state == 1) {
              selectNum += 1;
              break;
            }
          }
          item.state = selectNum > 0 ? 1 : 0;
        }
        items[i] = item;
      }
      that.items = items;
    },

    openBind: function () {
      this.$emit('changeParam');
    },

    /**
     * 获取参数
     */
    getParam: function () {
      var that = this;
      var params;
      var type = that.type;
      if (type == 'normal') {
        //获取普通选项参数
        params = that.getNormalParam();
      } else if (type == 'time') {
        //获取时间选项参数
        params = that.getTimeParam();
      } else if (type == 'area') {
        params = that.getAreaParam();
      } else if (type == 'keyword') {
        params = that.key;
      } else if (type == 'radio') {
        params = that.radioValue;
      } else if (type == 'etime') {
        // params = {}
        // var startTime = this.$moment(this.etimeValue[0]).format("HH:mm");
        // if(startTime!=null){
        //   params.startTime = startTime
        // }
        // var endTime = this.$moment(this.etimeValue[1]).format("HH:mm");
        //         if(startTime!=null){
        //   params.endTime = endTime
        // }
        params = {
          startTime: this.startTime,
          endTime: this.endTime
        };
      } else if (type == 'contentSub') {
        params = that.radioValue;
      } else if (type == 'objMoney') {
        params = [that.startMoney, that.endMoney];
      }
      return params;
    },
    //获取所有数据
    getAllData() {
      var data;
      var type = this.type;
      if (type == 'normal') {
        data = this.items;
      } else if (type == 'time') {
        data = this.timeData;
      } else if (type == 'area') {
        data = this.areaData;
      } else if (type == 'keyword') {
        data = this.key;
      } else if (type == 'radio') {
        data = this.items;
      } else if (type == 'etime') {
        data = this.items;
      }
      return data;
    },
    getNormalParam: function () {
      this.checkSelectState();
      var items = this.items;
      var params = [];
      if (items != null && items.length > 0) {
        for (var i = 0; i < items.length; i++) {
          var item = items[i];
          if (item.state == 1) {
            // if (item.list != null && item.list.length > 0) {
            //   var selectSmallList;
            //   for (var j = 0; j < item.list.length; j++) {
            //     if (item.list[j].state == 1) {
            //       if (selectSmallList == null) {
            //         selectSmallList = [];
            //       }
            //       selectSmallList.push(item.list[j]);
            //     }
            //   }
            //   item.list = selectSmallList;
            // }
            params.push(item);
          }
        }
      }
      return params;
    },
    getAreaParam: function () {
      var areaData = this.areaData;
      var list = areaData.list;
      var provinces = [];
      if (list != null && list.length > 0) {
        for (var i = 0; i < list.length; i++) {
          var area = list[i];
          var alist = area.list;
          if (alist != null && alist.length > 0) {
            for (var j = 0; j < alist.length; j++) {
              var province = alist[j];
              if (province.state == 1) {
                provinces.push(province);
              }
            }
          }
        }
      }
      return provinces;
    },

    getTimeParam: function () {
      // var that = this;
      // var timeValue = this.timeValue;
      // var startTime;
      // var endTime;
      // for (let i = 0; i < that.timeValue.length; i++) {
      //   startTime = that.$moment(that.timeValue[0]).format("YYYY-MM-DD");
      //   endTime = that.$moment(that.timeValue[1]).format("YYYY-MM-DD");
      // }
      
      return { startTime: this.startTime, endTime: this.endTime };
    },

    busClass: function (state) {
      switch (state) {
        case 0:
          return 'normal';
        case 1:
          return 'select';
        case 2:
          return 'show';
      }
    },
    areaClass: function (allState, parentState, state) {
      if (state == 0) {
        return 'natural';
      } else if (state == 1) {
        return 'select';
      } else if (parentState == 0) {
        return 'natural';
      } else if (parentState == 1) {
        return 'select';
      } else if (allState == 0) {
        return 'natural';
      } else if (allState == 1) {
        return 'select';
      }
    },
    estartTimeChange(data) {
      this.type_etime.endPicker_options.start = data;
    },
    eendTimeChange(data) { },
    startTimeChange(data) {
      var timeData = this.timeData;
      for (var i = 0; i < timeData.length; i++) {
        timeData[i].state = 0;
      }
      this.timeData = timeData;
      var startTime = new Date(data);
      var endTime = new Date(this.endTime);
      if (startTime > endTime) {
        console.log('开始 时间比较大');
        this.startTime = this.endTime;
        this.endTime = data;
      }
      this.openBind();
    },
    endTimeChange(data) {
      var timeData = this.timeData;
      for (var i = 0; i < timeData.length; i++) {
        timeData[i].state = 0;
      }
      this.timeData = timeData;
      var startTime = new Date(this.startTime);
      var endTime = new Date(data);
      if (startTime > endTime) {
        this.endTime = this.startTime;
        this.startTime = data;
      }
      this.openBind();
    },
    // 修改开始时间
    setStartTime: function (startTime) {
      this.startTime = startTime;
    },
    // 修改结束时间
    setEndTime: function (endTime) {
      this.endTime = endTime;
    },
    // 修改单选选项
    setRadioValue: function (radioValue) {
      this.radioValue = radioValue;
    },
    // 修改关键字
    setKey: function (key) {
      this.key = key;
    },
    keyFocusFn() {
      this.keyFocus = true;
    },
    keyBlurFn() {
      var that = this;
      setTimeout(function () {
        that.keyFocus = false;
      }, 250);
    },
    clickKeyTip(value) {
      console.log(value);
      this.keyFocus = false;
      this.key = value;
    },
    selectNewTime() {
      if (this.startTime && this.endTime) {
        var today = this.$moment(new Date()).format('YYYY-MM-DD');
        if (this.endTime == today) {
          var start = new Date(this.startTime);
          var end = new Date(this.endTime);
          if (this.timeData != undefined) {
            this.timeData.forEach(e => {
              e.state = 0;
            });
            if (end.getTime() - start.getTime() == 7 * 24 * 60 * 60 * 1000) {
              this.timeData[0].state = 1;
            } else if (end.getTime() - start.getTime() == 15 * 24 * 60 * 60 * 1000) {
              this.timeData[1].state = 1;
            } else if (end.getTime() - start.getTime() == 30 * 24 * 60 * 60 * 1000) {
              this.timeData[2].state = 1;
            } else if (end.getTime() - start.getTime() == 90 * 24 * 60 * 60 * 1000) {
              this.timeData[3].state = 1;
            } else if (end.getTime() - start.getTime() == 180 * 24 * 60 * 60 * 1000) {
              this.timeData[4].state = 1;
            } else if (end.getTime() - start.getTime() == 365 * 24 * 60 * 60 * 1000) {
              this.timeData[5].state = 1;
            }
          }
        }
      }
    }
  },

  created() {
    //快速选择年份的左边快捷选择    2018 - 当前年
    let date2018 = new Date(this.pickerOptionsStartNow);
    let yearDifference = new Date().getFullYear() - date2018.getFullYear();
    let tempShortcuts = [];
    for (let i = 0; i <= yearDifference; i++) {
      let tempDate = new Date().setFullYear((new Date().getFullYear() - i))
      let tempYear = new Date(tempDate).getFullYear();
      let param = {
        text: (tempYear + '年'),
        onClick(picker) {
          picker.$emit('pick', tempDate);
        }
      }
      tempShortcuts.push(param);
    }
    this.pickerOptionsYearStart.shortcuts = tempShortcuts;
    //快速选择年份的左边快捷选择End
  },
  mounted() {
    if (this.keyword != null) {
      this.key = this.keyword;
    }
    if (this.radioDefaultValue == 60) {
      this.radioValue = 60;
    } else if (this.radioDefaultValue == 1) {
      this.radioValue = 1;
    } else if (this.radioDefaultValue == 0) {
      this.radioValue = 0;
    }
    console.log(10.2);
    // if (this.onload == null) {
    //   console.log(10);
    //   if (this.timeData != null) {
    //     for (var i = 0; i < this.timeData.length; i++) {
    //       if (this.timeData[i].state == 1) {
    //         console.log(10.6);
    //         this.timeType_selected(this.timeData[i].id - 1);
    //         this.onload = false;
    //         break;
    //       }
    //     }
    //     if (this.onload != false) {
    //       this.startTime = this.$root.exportStartTime;
    //       this.endTime = this.$root.exportEndTime;
    //     }
    //   }
    // } else {
    //   // this.timeValue = this.defaultTime;
    //   if (this.defaultTime != null && this.defaultTime.length > 1) {
    //     this.startTime = this.defaultTime[0];
    //     this.endTime = this.defaultTime[1];
    //   }
    // }


    if (this.noYear == null) {
      if (this.startTime == null || this.startTime == '') {
        if (this.isSecond == null) {
          this.startTime = this.$root.searchTenderTimeStart;
        } else {
          this.startTime = this.$root.searchTenderTimeStartSecond;
        }
      }
      if (this.endTime == null || this.endTime == '') {
        if (this.isSecond == null) {
          this.endTime = this.$root.searchTenderTimeEnd;
        } else {
          this.endTime = this.$root.searchTenderTimeEndSecond;
        }
      }
    }

    // if (this.type == 'time') {
    //   var timeData = this.timeData;
    //   var index;
    //   if (timeData != null && timeData.length > 0) {
    //     for (var i = 0; i < timeData.length; i++) {
    //       if (timeData[i].state == 1) {
    //         index = timeData[i].id - 1;
    //         break;
    //       }
    //     }
    //   }
    //   console.log(index);
    //   if (index == 6) {
    //     this.startTime = null;
    //     this.endTime = null;
    //   }
    //   this.timeType_selected(index);
    // }
    
    //把日期显示出来
    this.$nextTick(() => {
      const end = new Date();
      const start = new Date();
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 365);
      this.startTime = new base().formatDate(start);
      this.endTime = new base().formatDate(end);
    })

  },
  watch: {
    key(newVal, oldVal) {
      var that = this;
      console.log('that.lxUrl:', that.lxUrl);
      if (that.lxUrl != null && that.lxUrl != '') {
        that.requestApi({
          url: that.lxUrl,
          method: 'get',
          data: { value: that.key },
          then(res) {
            that.zzList = res.data;
          }
        });
      } else {
        that.zzList = '';
      }
    },
    startTime() {
      this.selectNewTime();
    },
    endTime() {
      this.selectNewTime();
    }
  }
};
</script>

<style scope>
.searchItem {
  min-height: 26px;
  position: relative;
  padding: 0 20px 0 100px;
  clear: both;
}

.searchItemLeft {
  position: absolute;
  left: 20px;
  top: 0;
  width: 70px;
  text-align: right;
}

.searchItemLeft span {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  display: inline-block;
}

.searchItemContentItem {
  float: left;
  position: relative;
  z-index: 5;
}

.searchItemContentItem span {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  margin-right: 10px;
  padding: 0 10px;
  cursor: pointer;
  margin-bottom: 9px;
  display: inline-block;
}

.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 150px;
}

.searchItemContentItem .el-date-editor .el-input {
  width: 150px;
}

.searchItemContentItem span.el-radio__input {
  margin-right: 0;
  padding: 0;
  width: 23px;
}

.searchItemContentItem span.el-radio__input.is-checked .el-radio__inner,
.searchItemContentItem span.el-radio__inner {
  padding: 0;
  width: 18px;
  height: 18px;
  margin-top: 8px;
}

.searchItemContentItem span.el-radio__input.is-checked .el-radio__inner {
  border-color: #228ea4;
  background: linear-gradient(165deg, rgba(51, 107, 142, 1) 0%, rgba(36, 137, 161, 1) 55%, rgba(25, 159, 175, 1) 100%);
}

.searchItemContentItem .el-radio__input.is-checked+.el-radio__label {
  color: #2b5f80;
}

.searchItemContent .small {
  background: #fff;
  border-top: 1px solid #55adc2;
  border-bottom: 1px solid #55adc2;
  font-size: 14px;
  clear: both;
  position: relative;
  top: -10px;
  text-align: left;
}

.searchItemContent .smallItem {
  display: inline-block;
}

.small span {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  margin-right: 10px;
  padding: 0 10px;
  cursor: pointer;
  display: inline-block;
  margin: 5px 10px 5px 0;
}

.keyword {
  float: left;
  width: 400px;
  height: 26px;
  line-height: 26px;
  font-size: 14px;
  text-indent: 10px;
  border: 1px solid rgba(207, 207, 207, 1);
}

/* 地区样式 */
.searchAreaContentItem span {
  float: left;
  font-size: 14px;
  height: 24px;
  line-height: 24px;
  margin-right: 10px;
  margin-bottom: 10px;
  padding: 0 10px;
  cursor: pointer;
}

.levelOneArea {
  height: 26px;
}

/* 时间 */
.searchItem .timeSelect,
.selectYear {
  float: left;
  display: flex;
  justify-content: center;
  align-items: Center;
}

.searchItem .el-range-editor.el-input__inner {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  width: 300px;
  align-content: center;
  align-items: center;
  vertical-align: center;
}

.searchItem .el-input--prefix .el-input__inner {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  width: 150px;
}

.searchItemContent .el-radio__label {
  margin: 0;
  padding: 0;
}

.demonstration {
  font-size: 14px;
  height: 26px;
  line-height: 26px;
  width: 100px;
  vertical-align: center;
}

/* 公用 */
.select {
  background: linear-gradient(162deg, rgba(51, 107, 142, 1) 0%, rgba(25, 159, 175, 1) 100%);
  color: #fff;
}

.searchItemContentItem .show {
  border-top: 1px solid #55adc2;
  border-left: 1px solid #55adc2;
  border-right: 1px solid #55adc2;
  color: #2b5f80;
  background: #fff;
  /* margin-bottom: 0; */
}

.searchItemContent .timeSelect {
  margin-bottom: 10px;
}

.clear {
  clear: both;
}

.verticalLine {
  float: left;
  /* background-color: rgba(151, 151, 151, 1); */
  width: 1px;
  height: 26px;
  margin-right: 10px;
  background: url(../../common/img/line2.png) right center no-repeat;
}

.searchItem .searchTips {
  position: absolute;
  top: 30px;
  left: 0;
  z-index: 90;
  padding-top: 8px;
}

.searchItem .searchTips em img {
  position: absolute;
  top: 0;
  left: 470px;
}

.searchItem .searchTips .tipsCon {
  background: #fff;
  /* margin: 0 20px 0 98px; */
  margin: 0 20px 0 400px;
  text-align: left;
  padding: 10px;
  line-height: 20px;
  font-size: 12px;
  color: #535353;
  border: 1px solid #eee;
}

.keyTips {
  position: absolute;
  background-color: #ffffff;
  border: 1px solid rgb(207, 207, 207);
  width: 400px;
  height: 100px;
  text-align: left;
  font-size: 14px;
  bottom: -100px;
  z-index: 6;
  overflow-x: auto;
}

.keyTips div {
  padding-left: 10px;
  line-height: 22px;
  border-bottom: 1px solid rgb(207, 207, 207);
}

.keyTips div:hover {
  color: #ffffff;
  background: #2489a1;
}

.keyTips::-webkit-scrollbar {
  /*滚动条整体样式*/
  width: 7px;
  /*高宽分别对应横竖滚动条的尺寸*/
  height: 1px;
  float: right;
}

.keyTips::-webkit-scrollbar-thumb {
  border-radius: 10px;
  background: #c4c1c1;
}

.keyTips::-webkit-scrollbar-track {
  background: #ededed;
}

.hui {
  background-color: rgba(0, 0, 0, 0.06);
}
</style>



// WEBPACK FOOTER //
// src/components/searchItem/searchItem.vue